import { combineReducers } from "redux";
import authReducer from "./authReducer";
import chartItems from './chartReducer';
import userReducer from "./userReducer";
import walkTestReducer from './walkTestReducer';

export default combineReducers({
  auth: authReducer,
  chart: chartItems,
  user: userReducer,
  walkTest: walkTestReducer
});
